import { ApiCall } from '@lcms/api-definition';
import { endpoints } from '../../endpoints';

export const stayAliveEndpoint = new ApiCall().get('stayAlive', { route: endpoints.stayAlive, nativeProcessing: true });